import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useState } from 'react';
import TruncateMarkup from 'react-truncate-markup';
import { propShape } from '../../../../../helpers/custom-prop-types';
import SvgInline from '../../../../Ui/Common/SvgInline';
import Tooltip from '../../../../Ui/Tooltip/Tooltip';
const ProfessionalUnitExperiencedIndustry = (props) => {
    const { industryClass } = props;
    const { className, file, name } = industryClass;
    const [isTruncated, changeIsTruncated] = useState(false);
    return (_jsxs("li", Object.assign({ className: 'industry_column' }, { children: [_jsx("div", Object.assign({ className: clsx('column_icon experienced_tile', className) }, { children: _jsx(SvgInline, { className: 'icon_image', src: file, wrapperClassName: 'icon_image_box' }) })), _jsx("div", Object.assign({ className: 'column_text' }, { children: _jsx(Tooltip, Object.assign({ disabled: !name || !isTruncated, html: name }, { children: _jsx(TruncateMarkup, Object.assign({ lines: 1, onTruncate: changeIsTruncated }, { children: _jsx("div", { children: name }) })) })) }))] })));
};
ProfessionalUnitExperiencedIndustry.propTypes = {
    industryClass: propShape().isRequired,
};
export default ProfessionalUnitExperiencedIndustry;
